<chart
	[nbSpinner]="loading"
	nbSpinnerStatus="primary"
	nbSpinnerSize="large"
	class="progress-chart"
	type="line"
	[data]="data"
	[options]="options"
></chart>
